// Phase Navigation Reducer
// Handles phase transitions, back navigation, and error states

import type { ClaimState, ClaimAction } from './types';
import { getPreviousPhase } from '../constants';

export function phaseReducer(state: ClaimState, action: ClaimAction): ClaimState | null {
  switch (action.type) {
    case 'GO_TO_PHASE':
      return {
        ...state,
        previousPhase: state.phase,
        phase: action.phase,
        error: null,
      };

    case 'GO_BACK': {
      const prev = getPreviousPhase(state.phase);
      if (!prev) return null;
      return {
        ...state,
        previousPhase: state.phase,
        phase: prev,
      };
    }

    case 'SET_ERROR':
      return {
        ...state,
        error: action.error,
        phase: action.error ? 'error' : state.phase,
      };

    default:
      return null;
  }
}
